import constants from "../constants/roomConstants";
import jwt_decode from 'jwt-decode';
import { basicGet } from '../helpers/apiHelper';

export const getRooms = async (dispatch, getState) => {

    /*const auth = await get(constants.LOCAL_STORAGE_ID);

    if (auth) {
        dispatch({
            type: constants.SET_AUTH,
            authToken: auth,
            identity: jwt_decode(auth)
        });
    } else {

        //request guest auth from the api

        let response = await basicGet("Guest", "Create", {});

        if (response.success) {

            dispatch({
                type: constants.SET_AUTH,
                authToken: response.data.token,
                identity: jwt_decode(response.data.token)
            });

            set(constants.LOCAL_STORAGE_ID, response.data.token);
        }
    }*/


    let response = await basicGet("Room", "GetAll", {});

    if (response.success) {

        dispatch({
            type: constants.SET_ROOMS,
            rooms: response.data
        });

    }

    
}
